import { useEffect } from "react";
import { ACCENT_HUES } from "../lib/preferences";
import { useUiStore } from "../stores/ui.store";

/** Keeps the `dark` class on <html> in sync with the preference and the OS setting. */
export function useApplyTheme(): void {
  const theme = useUiStore((state) => state.theme);
  const accent = useUiStore((state) => state.accent);

  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => {
      const dark = theme === "dark" || (theme === "system" && media.matches);
      document.documentElement.classList.toggle("dark", dark);
    };
    apply();
    media.addEventListener("change", apply);
    return () => {
      media.removeEventListener("change", apply);
    };
  }, [theme]);

  // Indigo is the stylesheet default; any other accent supplies a hue that `index.css` turns into
  // the primary and ring colors for both modes.
  useEffect(() => {
    const root = document.documentElement;
    if (accent === "indigo") {
      root.removeAttribute("data-accent");
      root.style.removeProperty("--accent-hue");
    } else {
      root.setAttribute("data-accent", accent);
      root.style.setProperty("--accent-hue", String(ACCENT_HUES[accent]));
    }
  }, [accent]);
}
